import { Component, inject } from '@angular/core';
import { AppInstallService } from 'app/core/pwa/app-install.service';
import { RouterOutlet } from '@angular/router';
import { AppearanceService } from './core/appearance/appearance.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    private readonly appearance = inject(AppearanceService);
    // Capture installation availability before a user opens the menu.
    private readonly appInstall = inject(AppInstallService);
    /**
     * Constructor
     */
    constructor() {}
}
